import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { CalendarDotsIcon } from '@phosphor-icons/react';
import dayjs from 'dayjs';
import { Fragment, useState } from 'react';

import { StyledChip } from '@/components/common/StyledChip';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { TimeType } from '@/types/TimeType';

export function DateForm() {
  const time = useRoutesStore((state) => state.time);
  const { updateTime } = useRoutesStore((state) => state.actions);
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  return (
    <Fragment>
      <Typography fontWeight={500}>Datum und Uhrzeit</Typography>
      <form>
        <Stack gap={1.5}>
          <RadioGroup
            row
            value={time.type}
            onChange={(event) => {
              updateTime({ type: event.target.value as TimeType });
            }}
          >
            <FormControlLabel control={<Radio />} label="Abfahrt" sx={{ paddingLeft: 2 }} value={TimeType.DEPARTURE} />
            <FormControlLabel control={<Radio />} label="Ankunft" sx={{ paddingLeft: 2 }} value={TimeType.ARRIVAL} />
          </RadioGroup>
          <Stack direction="row" flexWrap="wrap" gap={1}>
            <StyledChip
              label="Untersuchungsraum: Gewichtung aktiv"
              onClick={() => updateTime({ date: dayjs('2026-07-06 12:00:00.000+02:00') })}
              size="small"
            />
            <StyledChip
              label="IAA Mobility 2025"
              onClick={() => updateTime({ date: dayjs('2025-09-10 12:00:00.000+02:00') })}
              size="small"
            />
            <StyledChip
              label="München Marathon 2025"
              onClick={() => updateTime({ date: dayjs('2025-10-12 12:00:00.000+02:00') })}
              size="small"
            />

            <Typography ml={1} variant="caption">
              TUM Audimax Evakuierung:
            </Typography>
            <StyledChip
              label="300 Meter"
              onClick={() => updateTime({ date: dayjs('2025-11-08 12:00:00.000+01:00') })}
              size="small"
            />
            <StyledChip
              label="500 Meter"
              onClick={() => updateTime({ date: dayjs('2025-11-09 12:00:00.000+01:00') })}
              size="small"
            />
            <StyledChip
              label="1000 Meter"
              onClick={() => updateTime({ date: dayjs('2025-11-10 12:00:00.000+01:00') })}
              size="small"
            />
          </Stack>
          <DateTimePicker
            ampm={false}
            format="DD.MM.YYYY HH:mm"
            onClose={() => setDatePickerOpen(false)}
            onOpen={() => setDatePickerOpen(true)}
            open={datePickerOpen}
            value={time.date}
            onChange={(value) => {
              if (value) {
                updateTime({ date: value });
              }
            }}
            slotProps={{
              textField: {
                variant: 'filled',
                size: 'small',
                fullWidth: true,
                InputProps: {
                  disableUnderline: true,
                  startAdornment: (
                    <CalendarDotsIcon
                      color="#0000008F"
                      onClick={() => setDatePickerOpen(true)}
                      size={24}
                      style={{ marginLeft: 6, marginRight: 8, cursor: 'pointer' }}
                      weight="fill"
                    />
                  ),
                },
                sx: {
                  marginTop: 1,
                  backgroundColor: 'white',
                  height: 40,
                  borderRadius: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',

                  '& .MuiPickersFilledInput-root': {
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                    '&.Mui-focused': {
                      backgroundColor: 'white',
                    },
                  },

                  '& .MuiPickersSectionList-root': {
                    padding: 0,
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                  },

                  '& input': {
                    padding: '0 12px',
                  },
                },
              },
            }}
            slots={{
              openPickerIcon: () => null,
            }}
          />
        </Stack>
      </form>
    </Fragment>
  );
}
